import { render, staticRenderFns } from "./newThreadDialog.vue?vue&type=template&id=40777f26&"
import script from "./newThreadDialog.vue?vue&type=script&lang=js&"
export * from "./newThreadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40777f26')) {
      api.createRecord('40777f26', component.options)
    } else {
      api.reload('40777f26', component.options)
    }
    module.hot.accept("./newThreadDialog.vue?vue&type=template&id=40777f26&", function () {
      api.rerender('40777f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/forum/components/newThreadDialog.vue"
export default component.exports